import React from 'react'

import Reviews from './Reviews';

import peter from '../images/Peter-kleur.png';
import img_me from '../images/Polymedia-Peter_van_der_Meer.jpg';
import polymedia_peter from '../images/polymedia-peter-van-der-meer-black.png';
import casestudy from '../images/dieet-club-facebook-cover.jpg';


export default class extends React.Component {

  render() {
    document.title = "Groei & automatisering voor jouw bedrijf | Peter van der Meer | INFLOW Online Marketing Bureau | Helpt jouw bedrijf groeien.";

    return (
      <div>

        <div className="full blue" style={{paddingTop:"8em", paddingBottom:"8em"}}>

          <div className="wrap">
            <div className="col-2" style={{padding:"3%"}}>
              <h2 className="logo-text" style={{marginBottom:".3em"}}>Peter van der Meer <span style={{opacity:".7"}}>Marketing</span></h2>
              <h1 className="header-responsive" style={{fontFamily:"Times New Roman, Times, serif", marginTop:"0", marginBottom:".3em"}}>Groei & Automatisering.</h1>
              <h2 style={{fontSize:"1.1em", opacity:".7", margin:"1em 0 4.3em"}}>Ik help bedrijven in heel Nederland te ontdekken hoe ze meer kunnen groeien en automatiseren met geavanceerde tools en Artificial Intelligence.</h2>
              <div style={{marginBottom:"5em"}}><a href="/contact" className="btn btn-fat btn-if btn-if-fill-red">Neem contact op</a><a href="/contact"><img src={img_me} alt="INFLOW Online Marketing | Peter van der Meer" style={{marginTop:"-36px", marginLeft:"14px", borderRadius:"50%", border:"3px solid #fff", width:"90px"}} /></a></div>
            </div>
            <div className="col-2" style={{textAlign:"center"}}>
              <div style={{position:"relative"}}>
                <img src={peter} alt="INFLOW Online Marketing | Welkom!" style={{width:"530px", maxWidth:"70%", borderRadius:"50%"}} />
                <svg style={{position:"absolute", top:"77px", right:"50px", maxWidth:"22%", maxHeight:"22%"}} height="100px" width="100px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 297.37 297.37"><g><g><path style={{fill:"#0DAA99"}} d="M18.83,33.994c0,0,21.751,329.063,138.691,251.557S278.54,93.824,278.54,93.824l-58.47-48.952C141.204,44.872,36.502,0,36.502,0L18.83,33.994z"/></g></g></svg>
                <svg style={{position:"absolute", bottom:"10px", left:"80px", maxWidth:"22%", maxHeight:"22%"}} height="100px" width="100px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 368.935 368.935"><g><g><path style={{fill:"#E798AB"}} d="M330.835,0C130.884,155.665,85.659,39.304,85.659,39.304c-113.127,128.764,0,246.284,0,246.284 c199.953-78.446,44.039,83.347,44.039,83.347C372.496,355.46,330.835,0,330.835,0z"/></g></g></svg>
                <svg style={{position:"absolute", left:"22px", maxWidth:"22%", maxHeight:"22%"}} height="100px" width="100px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 285.93 285.93"><g><g><path style={{fill:"#F2AA22"}} d="M131.328,285.93c59.792-29.474,140.447-26.967,140.447-26.967v-55.299 C134.89,89.444,240.952,42.304,240.952,42.304c-255.636-95.184-225.721,0-225.721,0S14.736,216.713,14.41,285.93H131.328z"/></g></g></svg>
              </div>
            </div>
          </div>

        </div>

        <i id="voordelen"/>
        <div className="full greyish">
          <div className="wrap content-block">
            <h2>Voordelen</h2>
            <div className="col-2 usp">
              <h3>Meer ogen op jou</h3>
              <p>Wie weet van het bestaan van jouw bedrijf af? Vrienden en familie? Met marketing krijg je meer ogen op jouw bedrijf. Dit levert meer contacten op, meer samenwerkingen, meer kansen, en ook meer klanten.</p>
              <h3>Meer merkherkenning</h3>
              <p>Belangrijk voor een bedrijf is om een sterk merk te hebben, waardoor je nieuwe klanten niet hoeft te overtuigen van jouw waarde. Dit zorgt ook voor loyale klanten, werknemers die trots zijn om met jou te werken, en positieve mond-tot-mondreclame.</p>
            </div>
            <div className="col-2 usp">
              <h3>Meer leads</h3>
              <p>Marketing zorgt direct voor meer leads, mensen die interesse hebben in wat jij te bieden hebt. Of een lead ook overgaat tot aankoop is een tweede stap, maar marketing zorgt voor meer kansen om mensen te overtuigen van jouw product of dienst.</p>
              <h3>Meer klanten</h3>
              <p>Het doel van marketing is niet direct meer klanten, maar dit is meestal wel het resultaat. Meer mensen kennen je, weten je te vinden, hebben van jouw bedrijf gehoord, of kennen mensen die gebruik maken van jouw product of dienst. Dit zorgt voor meer interesse en meer klanten.</p>
            </div>
          </div>
        </div>

        <i id="reviews"/>
        <Reviews limited />

        <i id="diensten"/>
        <div className="full big greyish">
          <div className="wrap content-block">
            <div className="col-2" style={{margin:"0 auto", display:"block"}}>
              <section>
                <h1 style={{marginBottom:".7em"}}>Groei & automatisering voor jouw bedrijf</h1>

                <p>
                  Meer reviews. Snellere leadopvolging. Minder handmatig werk.
                </p>
                <br/>
                <p>
                  Met INFLOW help ik bedrijven groeien door klantopvolging,
                  marketing en terugkerende processen slim te automatiseren.
                </p>
                <br/>
                <a href="#contact">Bespreek wat ik voor je kan automatiseren</a>
              </section>


              <section>
                <h2 style={{marginTop:"2em", marginBottom:".3em"}}>Waar kan ik je mee helpen?</h2>

                <table>
                  <thead>
                    <tr>
                      <th>Dienst</th>
                      <th>Wat ik automatiseer</th>
                      <th>Resultaat</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr>
                      <td>Review automatisering</td>
                      <td>Klanten automatisch om reviews en feedback vragen</td>
                      <td>Meer reviews en social proof</td>
                    </tr>

                    <tr>
                      <td>Lead follow-up</td>
                      <td>Nieuwe leads automatisch registreren en opvolgen</td>
                      <td>Minder leads die verloren gaan</td>
                    </tr>

                    <tr>
                      <td>AI & automatisering</td>
                      <td>Terugkerende taken automatiseren met AI en slimme workflows</td>
                      <td>Minder administratie en handmatig werk</td>
                    </tr>
                  </tbody>
                </table>
              </section>


              <section>
                <h2 style={{marginTop:"2em", marginBottom:".3em"}}>Review automatisering</h2>

                <p>
                  Tevreden klanten laten niet altijd vanzelf een review achter.
                  Ik kan een systeem voor je bouwen dat klanten automatisch op het
                  juiste moment om feedback of een review vraagt.
                </p>

                <ul style={{marginTop:"1em"}}>
                  <li>Automatische reviewverzoeken</li>
                  <li>Automatische herinneringen</li>
                  <li>Google Reviews verzamelen</li>
                  <li>Feedback automatisch verwerken</li>
                </ul>
              </section>


              <section>
                <h2 style={{marginTop:"2em", marginBottom:".3em"}}>Automatische lead follow-up</h2>

                <p>
                  Een nieuwe lead moet snel worden opgevolgd. Ik kan jouw formulieren,
                  e-mail, CRM, WhatsApp en andere systemen aan elkaar koppelen,
                  zodat iedere aanvraag automatisch in de juiste flow terechtkomt.
                </p>

                <table style={{marginTop:"1em"}}>
                  <tbody>
                    <tr>
                      <th>Nieuwe aanvraag</th>
                      <td>Automatisch opslaan in CRM</td>
                    </tr>

                    <tr>
                      <th>Direct daarna</th>
                      <td>Bevestiging of eerste follow-up versturen</td>
                    </tr>

                    <tr>
                      <th>Geen reactie</th>
                      <td>Automatische herinnering versturen</td>
                    </tr>

                    <tr>
                      <th>Afspraak geboekt</th>
                      <td>Bevestiging en reminder versturen</td>
                    </tr>
                  </tbody>
                </table>
              </section>


              <section>
                <h2 style={{marginTop:"2em", marginBottom:".3em"}}>AI-tools & automatisering</h2>

                <p>
                  AI is vooral interessant als het daadwerkelijk werk uit handen neemt.
                  Ik kijk waar binnen jouw bedrijf terugkerende taken onnodig veel tijd
                  kosten en welke daarvan slim geautomatiseerd kunnen worden.
                </p>

                <ul style={{marginTop:"1em"}}>
                  <li>Leads automatisch kwalificeren</li>
                  <li>E-mails en documenten samenvatten</li>
                  <li>CRM-gegevens automatisch verwerken</li>
                  <li>Inkomende aanvragen categoriseren</li>
                  <li>Conceptantwoorden genereren</li>
                  <li>Software met elkaar koppelen</li>
                </ul>
              </section>


              <section>
                <h2 style={{marginTop:"2em", marginBottom:".3em"}}>Hoe werkt het?</h2>

                <ol style={{marginTop:"1em"}}>
                  <li>
                    <strong>Analyse: </strong>
                    ik bekijk welk proces onnodig veel tijd kost.
                  </li>

                  <li>
                    <strong>Ontwerp: </strong>
                    ik bepaal samen met jou welke stappen geautomatiseerd kunnen worden.
                  </li>

                  <li>
                    <strong>Bouw: </strong>
                    ik richt de automatisering in en koppel de benodigde systemen.
                  </li>

                  <li>
                    <strong>Test: </strong>
                    ik controleer of alles betrouwbaar werkt voordat het proces live gaat.
                  </li>
                </ol>
                <br/>
                <p>
                  Waar mogelijk werk ik met software die je al gebruikt, zoals
                  CRM-systemen, e-mailsoftware, Google Sheets, formulieren, agenda's,
                  Make, Zapier, n8n en AI-tools.
                </p>
              </section>


              <section>
                <h2 style={{marginTop:"2em", marginBottom:".3em"}}>Begin met één proces</h2>

                <p>
                  Je hoeft niet meteen je hele bedrijf te automatiseren.
                  Vaak is één duidelijk proces een betere plek om te beginnen.
                </p>

                <ul style={{marginTop:"1em"}}>
                  <li>Meer reviews verzamelen</li>
                  <li>Nieuwe leads automatisch opvolgen</li>
                  <li>Je CRM automatisch vullen</li>
                  <li>Een terugkerende administratieve taak automatiseren</li>
                  <li>Een eenvoudige interne AI-tool bouwen</li>
                </ul>
              </section>


              <section>
                <h2 style={{marginTop:"2em", marginBottom:".3em"}}>Veelgestelde vragen</h2>

                <h3 style={{marginTop:"2em", marginBottom:".3em"}}>Wat doet INFLOW?</h3>
                <p>
                  Met INFLOW help ik bedrijven met automatisering rondom reviews,
                  leads, marketing en terugkerende werkzaamheden.
                </p>

                <h3 style={{marginTop:"2em", marginBottom:".3em"}}>Moet ik al precies weten wat ik wil automatiseren?</h3>
                <p>
                  Nee. Ik kan met je meekijken naar je huidige proces en aangeven
                  waar automatisering waarschijnlijk de meeste tijd of handmatig werk bespaart.
                </p>

                <h3 style={{marginTop:"2em", marginBottom:".3em"}}>Kun je mijn bestaande software gebruiken?</h3>
                <p>
                  Ja. Waar mogelijk koppel ik je bestaande systemen aan elkaar,
                  zodat je niet onnodig nieuwe software hoeft te gebruiken.
                </p>
              </section>


              <section id="contact">
                <h2 style={{marginTop:"2em", marginBottom:".3em"}}>Minder handmatig werk. Meer flow.</h2>

                <p>
                  Vertel me welk proces binnen jouw bedrijf iedere week opnieuw tijd kost.
                  Ik kijk graag met je mee naar wat er slimmer kan.
                </p>

                <div style={{ textAlign:"center", margin: "1.7em 0" }}><a href="/contact" className="btn btn-fat btn-if btn-if-fill-green">Laat je proces bekijken <span style={{ fontSize: "150%", lineHeight: "0" }}>&rarr;</span></a></div>
              </section>
            </div>
          </div>
        </div>

        <i id="kennismaken"/>
        <div className="full big accent" style={{background:"#116CB2"}}>
          <div className="wrap content-text">
            <h2 className="cta-title" style={{color:"#F2AA22"}}>Vrijblijvend kennismaken?</h2>
            <p style={{textAlign:"center", opacity:"0.8"}}>Benieuwd wat ik kan betekenen voor jouw bedrijf, stichting, of museum?<br/><br/>Plan direct een kennismaking in.</p>
            <div style={{textAlign:"center"}}><a href="/contact" className="btn btn-fat btn-if btn-if-fill-red">Naar contact-pagina</a></div>
          </div>
        </div>

        <i id="portfolio"/>
        <div className="full big">
          <div className="wrap content-block" style={{textAlign:"center"}}>
            <h2>Portfolio</h2>
            <a href="/case-study-dieet-club"><img src={casestudy} alt="inflow.polymedia.nl | case study dieet.club" style={{maxWidth:"100%", borderRadius:"7px", marginBottom:"1em"}} /></a>
            <div><a href="/case-study-dieet-club" className="btn btn-fat btn-if btn-if-fill-orange">Case Study Dieet.Club</a></div>
          </div>
        </div>

        <i id="over"/>
        <div className="full big greyish">
          <div className="wrap content-block">
            <div className="col-2">
              <img src={polymedia_peter} alt="inflow.polymedia.nl | over Online Marketing inflow" className="screenshot" style={{margin:"0"}} />
            </div>
            <div className="col-2">
              <h1 style={{margin:"1rem 0", textAlign:"center"}}>Over Peter</h1>
              <p style={{fontSize:"20px", textAlign:"left", marginTop:"0"}}>
              Na jarenlang Facebook pagina's en advertenties te hebben gemaakt en beheerd heb ik besloten om mijn ervaring in te zetten om meer omzet te genereren voor andere mensen. Zo heb ik de pagina voor Serious Request Leerdam jarenlang beheerd, en met behulp van berichten en advertenties de pagina van 140 naar meer dan 1.100 volgers gebracht met een zeer klein budget. Daarnaast heb ik Facebook Advertenties ingezet voor meerdere persoonlijke projecten, zoals voor <a href="/case-study-dieet-club">Dieet Club</a>. Hier heb ik veel geëxperimenteerd met verschillende doelgroepen, afbeeldingen, en teksten, met als resultaat een zo gerichte campagne dat de Cost-Per-Click (CPC) 4,5 keer lager was dan het Nederlands gemiddelde.
              <br/><br/>
              Wie ben ik als persoon? Ik ben met veel dingen lichtelijk obsessief, vooral projecten en marketing laten me niet los, ik blijf dag en nacht nadenken over wat er nog beter kan. Ook ben ik erg resultaatgericht, ik wil graag meten en weten wat marketing doet en hoe iedere cent beter uitgegeven kan worden. Ik ben op zoek naar positieve feedback, dus ik wil graag goed werk afleveren.
              <br/><br/>
              Mijn doel is om meer omzet voor jouw bedrijf te genereren, dus neem direct contact op om te bespreken hoe ik jou kan helpen.
              </p>
              <div className="socials"><a href="https://www.linkedin.com/in/peterdotplus/" target="_blank" rel="noopener noreferrer" className="btn btn-fat btn-if btn-if-fill-orange">LinkedIn</a> <a href="https://www.facebook.com/inflow.marketing/" target="_blank" rel="noopener noreferrer" className="btn btn-fat btn-if btn-if-fill-orange">Facebook</a></div>
            </div>
          </div>
        </div>

        <i id="contact"/>
        <div className="full big">
          <div className="wrap content-block">
            <div style={{textAlign:"center"}}>
              <h1 style={{margin:"1rem 0 2rem", textAlign:"center"}}>Geen koffie en vlotte babbels.</h1>
              <p style={{fontSize:"20px", textAlign:"center", marginTop:"0", marginBottom:"5em"}}>
              Mijn naam is Peter van der Meer, en ik ben woonachtig in Leerdam (Utrecht). Na jarenlange ervaring met allerlei ondernemingen heb ik genoeg ervaring opgebouwd met marketing dat ik op het idee kwam om mijn eigen Online Marketing Bureau te beginnen. Mijn doel is om voor jou meer omzet te genereren.
              <br/><br/>
              Dit bedrijf werkt volledig remote, ik heb dus ook geen kantoor. Contact gaat in eerste instantie via E-mail en videobellen, en ook tijdens onze samenwerking heeft dit mijn voorkeur. Tijdens onze samenwerking kunnen we ook andere manieren van contact afspreken.
              <br/><br/>
              Benieuwd of ik jouw bedrijf kan helpen? Neem geheel vrijblijvend contact met mij op door een bericht te sturen via LinkedIn.
              </p>
              <div style={{marginBottom:"5em"}}><a href="/contact" className="btn btn-fat btn-if btn-if-fill-blue">Neem contact op</a><a href="/contact"><img src={img_me} alt="INFLOW Online Marketing | Peter van der Meer" style={{marginTop:"-36px", marginLeft:"14px", borderRadius:"50%", border:"3px solid #116CB2", width:"90px"}} /></a></div>
            </div>
          </div>
        </div>

        <div className="full big accent" style={{background:"#116CB2"}}>
          <div className="wrap content-text">
            <h2 className="cta-title" style={{color:"#F2AA22"}}>Vrijblijvend kennismaken?</h2>
            <p style={{textAlign:"center", opacity:"0.8"}}>Benieuwd wat ik kan betekenen voor jouw bedrijf, stichting, of museum?<br/><br/>Plan direct een kennismaking in.</p>
            <div style={{textAlign:"center"}}><a href="/contact" className="btn btn-fat btn-if btn-if-fill-red">Naar contact-pagina</a></div>
          </div>
        </div>

      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/containers/GrowthAutomation.js